// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1g8KA","errorLogs":"styles_errorLogs__3CDYn"};